'use client';

import { Button as HeroButton } from '@heroui/button';
import { gtEstiPro } from '@trwl/app/fonts';
import cn from 'classnames';

export const Button = ({
  children,
  ...args
}: Parameters<typeof HeroButton>[0]) => (
  <HeroButton
    size={'lg'}
    radius={'sm'}
    color={'primary'}
    {...args}
    disableRipple
    className={cn(
      'text-[17px] lg:text-[19px] h-[50px]',
      gtEstiPro.className,
      args.className,
    )}
  >
    {children}
  </HeroButton>
);
